export default __webpack_public_path__ + "static/media/cohort-construction.b9e89ffe.svg";